import { useRef } from "react";

import Table from "ds/components/Table";
import TableWrapper from "ds/components/Table/Wrapper";

import IacManagementTableBody from "./Body";
import IacManagementTableHead from "./Head";
import { RenderGroupRowContent, RenderResourceRowContent } from "./types";
import IacManagementTableSkeleton from "./Skeleton";

type IacManagementTableProps = {
  rowsPerPage: number;
  groupsLoading: boolean;
  renderGroupRow: RenderGroupRowContent;
  renderResourceRow: RenderResourceRowContent;
  hasPagination: boolean;
};

const IacManagementTable = ({
  rowsPerPage,
  groupsLoading,
  renderGroupRow,
  renderResourceRow,
  hasPagination,
}: IacManagementTableProps) => {
  const tableWrapperRef = useRef<HTMLDivElement>(null);

  return (
    <TableWrapper ref={tableWrapperRef} hasPagination={hasPagination}>
      <Table ariaLabel="IaC management table">
        <IacManagementTableHead tableRef={tableWrapperRef} />
        {groupsLoading && <IacManagementTableSkeleton rowsPerPage={rowsPerPage} />}
        {!groupsLoading && (
          <IacManagementTableBody
            tableWrapperRef={tableWrapperRef}
            renderGroupRow={renderGroupRow}
            renderResourceRow={renderResourceRow}
          />
        )}
      </Table>
    </TableWrapper>
  );
};

export default IacManagementTable;
